import { NotFoundSection } from '@onesource/components';

import { SimpleLayout } from 'src/layouts/simple';

// ----------------------------------------------------------------------

export function NotFoundView() {
  return (
    <SimpleLayout content={{ compact: true }}>
      <NotFoundSection />
    </SimpleLayout>
  );
}
